module.exports = __webpack_public_path__ + "static/media/PaymentsStepIcon.9f47f473.svg";